import { render, staticRenderFns } from "./NumberTrans.vue?vue&type=template&id=23020332&scoped=true"
import script from "./NumberTrans.vue?vue&type=script&lang=js"
export * from "./NumberTrans.vue?vue&type=script&lang=js"
import style0 from "./NumberTrans.vue?vue&type=style&index=0&id=23020332&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23020332",
  null
  
)

export default component.exports